import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import store from "./redux/store";
import { Provider } from "react-redux";
import { register } from "./serviceWorkerRegistration";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initExtensionBridge } from "./utils/extension-bridge";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000, // Previously cacheTime - data kept in cache for 30 minutes
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
});

// A deploy replaces the hashed chunk files, so a tab opened before the deploy
// can fail to lazy-load a route. Reload to pick up the new index.html.
window.addEventListener("vite:preloadError", () => {
  window.location.reload();
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  // <React.StrictMode>
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <App />
    </Provider>
  </QueryClientProvider>
  // </React.StrictMode>
);

register();

// Chrome extension auth handoff. Lives outside the React tree on purpose — see
// extra/extension-auth-bridge.md. Must be called (not just imported) so it
// survives tree-shaking.
initExtensionBridge();
